var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{domProps:{"innerHTML":_vm._s(_vm.$t('$app.md_editor.label'))}}),_c('textarea',{ref:"mdEditor"})])
}
var staticRenderFns = []

export { render, staticRenderFns }